<template>
  <div class="row">
    <div class="col-4">
        <AdminProjektInfos v-bind:bauprojekt_id="currentBauprojekt.id" />
        <AdminDienstleister v-bind:bauprojekt_id="currentBauprojekt.id" />
    </div>
    <div class="col-8">
      <AdminHauser v-bind:bauprojekt_id="currentBauprojekt.id" />
        <AdminProjektphasen v-bind:bauprojekt_id="currentBauprojekt.id" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AdminHauser from "@/widget/admin/AdminHauser.vue";
import AdminDienstleister from "@/widget/admin/AdminDienstleister.vue";
import AdminProjektInfos from "@/widget/admin/AdminProjektinfos.vue";
import AdminProjektphasen from "@/widget/Projektphasen.vue";

export default {
  name: "AdminBauprojekt",
  components: {
    AdminHauser,
    AdminDienstleister,
    AdminProjektInfos,
    AdminProjektphasen,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
    }),
    currentBauprojekt() {
      return this.bauprojekte.find((bauprojekt) => bauprojekt.id == this.$route.params.bauprojekt_id);
    },
  },
  methods: {
    async checkRelation(relation) {
      console.log(await this.$store.dispatch("app/checkCollectionRelations", relation));
    },
    debug: function() {
      console.log(this.$route);
    },
  },
};
</script>

<style scoped>
.status-container > div > span {
  vertical-align: super;
  margin-right: 15px;
  font-size: 20px;
}
</style>
